<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove this LOS price record from the accommodation {{hsfp.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rm1Hsfp">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

import {bus} from "../../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hsfp_encrid: null,
      hsfp: {}
    }
  },
  methods: {
    open(hsfp_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/getHsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsfp"
          },
          getHsfp: {
            hsfp_encrid: hsfp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfp = res.data.getHsfp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rm1Hsfp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/rm1Hsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rm1Hsfp"
          },
          rm1Hsfp: {
            hsfp_encrid: this.hsfp.hsfp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             if (res.data.rm1Hsfp.color == "success") {
                //this.$router.reload('/huis/hspt/hsfp/updHsfp/' + res.data.rm1Hsfp.hspt_encrid); 
                bus.$emit("closeDialog", "reload"); 
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rm1Hsfp.text,
              color: res.data.rm1Hsfp.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

